// City -> [lat, lng] for map marker placement (mirrors backend CITY_GEO).
export const CITY_COORDS = {
  Delhi: [28.6139, 77.209], "New Delhi": [28.6139, 77.209],
  Gurugram: [28.4595, 77.0266], Faridabad: [28.4089, 77.3178], Noida: [28.5355, 77.391],
  Mumbai: [19.076, 72.8777], Pune: [18.5204, 73.8567], Nashik: [19.9975, 73.7898],
  Chennai: [13.0827, 80.2707], Coimbatore: [11.0168, 76.9558], Madurai: [9.9252, 78.1198], Vellore: [12.9165, 79.1325],
  Bangalore: [12.9716, 77.5946], Bengaluru: [12.9716, 77.5946],
  Hyderabad: [17.385, 78.4867], Kolkata: [22.5726, 88.3639],
  Kochi: [9.9312, 76.2673], Thiruvananthapuram: [8.5241, 76.9366],
  Jaipur: [26.9124, 75.7873], Ahmedabad: [23.0225, 72.5714], Lucknow: [26.8467, 80.9462],
  Mohali: [30.7046, 76.7179], Bhubaneswar: [20.2961, 85.8245],
};

export function cityCoords(name) {
  return CITY_COORDS[name] || [20.5937, 78.9629];
}
